<template>
  <v-chip
    v-bind="$attrs"
    class="theme-chip"
    :class="{
      'theme-chip--small': small,
      'theme-chip--large': large,
      [`theme-chip--${color}`]: color,
    }"
    v-on="$listeners"
  >
    <v-icon
      v-if="icon"
      :left="!iconRight"
      :right="iconRight"
      :small="small"
      :large="large"
      class="theme-chip__icon"
    >
      {{ icon }}
    </v-icon>
    <span class="theme-chip__text">{{ text }}</span>
    <v-icon
      v-if="closeIcon"
      right
      small
      class="theme-chip__close"
      @click="$emit('close')"
    >
      mdi-close
    </v-icon>
  </v-chip>
</template>

<script>
export default {
  name: "ThemedIconTextChip",
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: null,
    },
    iconRight: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    closeIcon: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "default",
      validator: (value) =>
        [
          "default",
          "primary",
          "secondary",
          "success",
          "warning",
          "error",
          "info",
        ].includes(value),
    },
  },
  emits: ["close"],
};
</script>

<style scoped>
.theme-chip {
  background-color: var(--color-surface) !important;
  border: 1px solid var(--color-text) !important;
  color: var(--color-text) !important;
  font-weight: 500;
  font-size: 14px;
  border-radius: var(--radius-md) !important;
}

.theme-chip--small {
  font-size: 12px;
  padding: 4px 8px;
  height: 24px;
}

.theme-chip--small .theme-chip__icon {
  font-size: 14px;
  color: var(--color-text) !important;
}

.theme-chip--large {
  font-size: 16px;
  padding: 12px 16px;
  height: 40px;
}

.theme-chip--large .theme-chip__icon {
  font-size: 20px;
  color: var(--color-text) !important;
}

.theme-chip__icon {
  color: var(--color-text) !important;
}

.theme-chip__text {
  font-weight: 500;
  line-height: 1.2;
}

.theme-chip__close {
  color: var(--color-text-muted) !important;
  cursor: pointer;
  margin-left: 4px;
}

/* Color variants */
.theme-chip--primary {
  background-color: var(--color-primary) !important;
  color: white !important;
  border-color: var(--color-primary) !important;
}

.theme-chip--primary .theme-chip__icon {
  color: rgba(255, 255, 255, 0.8) !important;
}

.theme-chip--secondary {
  background-color: var(--color-secondary) !important;
  color: white !important;
  border-color: var(--color-secondary) !important;
}

.theme-chip--secondary .theme-chip__icon {
  color: rgba(255, 255, 255, 0.8) !important;
}

.theme-chip--success {
  background-color: var(--color-success) !important;
  color: white !important;
  border-color: var(--color-success) !important;
}

.theme-chip--success .theme-chip__icon {
  color: rgba(255, 255, 255, 0.8) !important;
}

.theme-chip--warning {
  background-color: var(--color-warning) !important;
  color: white !important;
  border-color: var(--color-warning) !important;
}

.theme-chip--warning .theme-chip__icon {
  color: rgba(255, 255, 255, 0.8) !important;
}

.theme-chip--error {
  background-color: var(--color-error) !important;
  color: white !important;
  border-color: var(--color-error) !important;
}

.theme-chip--error .theme-chip__icon {
  color: rgba(255, 255, 255, 0.8) !important;
}

.theme-chip--info {
  background-color: var(--color-info) !important;
  color: white !important;
  border-color: var(--color-info) !important;
}

.theme-chip--info .theme-chip__icon {
  color: rgba(255, 255, 255, 0.8) !important;
}
</style>
